module.exports = __webpack_public_path__ + "static/2-89de1957b62ad8045ff1084700430e83.jpg";